import { useWatch } from "react-hook-form";
import { SwitchInput } from "../SwitchInput";

const QUESTIONS = [
  {
    id: "corgi-medical-payments",
    name: "step8.corgiMedicalPayments",
    label: "Med pay?",
  },
  {
    id: "corgi-tria",
    name: "step8.corgiTriaCoverage",
    label: "Add Terrorism Risk Insurance Act Coverage to all elected coverages?",
  },
  {
    id: "corgi-um-uim",
    name: "step8.corgiUmUimCoverage",
    label: "Would you like Uninsured Motorist and Underinsured Motorist Coverage?",
  },
  {
    id: "corgi-tow-trucks",
    name: "step8.corgiTowTrucks",
    label: "Do you have tow trucks in your fleet?",
  },
];

export function CorgiCoverageQuestions({ control }) {
  const carriers = useWatch({ control, name: "step8.carrier" }) || [];
  if (!carriers.includes("Corgi Trucking")) return null;

  return (
    <div className="rounded-lg border p-4 space-y-4">
      <h3 className="text-lg font-semibold">Corgi Trucking Coverage Questions</h3>
      {QUESTIONS.map((question) => (
        <SwitchInput
          key={question.id}
          control={control}
          id={question.id}
          stepName={question.name}
          stepId="step8"
          label={question.label}
        />
      ))}
    </div>
  );
}
